export default __webpack_public_path__ + "c017af2af94f9f710ed5e47b973919ab.png";